<template>
    <div>
        <div class="form-row">
            <div class="form-group col-sm-12 col-md-6 col-lg-4">
                <label class="font-weight-bold">
                    {{$t('applicationSettings.signingSettings.turnOnCertificateSigning')}}
                </label>
                <vs-checkbox
                    v-model="value.turnOnCertificateSigning"
                    style="justify-content: flex-start !important"
                />
            </div>
            <div class="form-group col-sm-12 col-md-6 col-lg-4">
                <label class="font-weight-bold">
                    {{$t('applicationSettings.signingSettings.certificateDefaultAssigneeUsername')}}
                </label>
                <kendo-dropdownlist
                    v-if="users"
                    v-model="value.certificateDefaultAssigneeUsername"
                    :data-source="users"
                    data-text-field="text"
                    data-value-field="text"
                    :optionLabel="$t('choose')"
                    :filter="'contains'"
                    style="width: 100%;" />
            </div>
            <div class="form-group col-sm-12 col-md-6 col-lg-4">
                <label class="font-weight-bold">
                    {{$t('applicationSettings.signingSettings.defaultPdfSignatureVisualizatonType')}}
                </label>
                <kendo-dropdownlist
                    v-model="value.defaultPdfSignatureVisualizatonType"
                    :data-source="signatureVisualizationTypeOptions"
                    data-text-field="text"
                    data-value-field="id"
                    :optionLabel="$t('choose')"
                    style="width: 100%;" />
            </div>
            <div class="form-group col-sm-12 col-md-6 col-lg-4">
                <label class="font-weight-bold">
                    {{$t('applicationSettings.signingSettings.defaultPdfReason')}}
                </label>
                <input class="form-control"
                    type="text"
                    v-model="value.defaultPdfReason"
                />
            </div>
            <div class="form-group col-sm-12 col-md-6 col-lg-4">
                <label class="font-weight-bold">
                    {{$t('applicationSettings.signingSettings.defaultPdfContact')}}
                </label>
                <input class="form-control"
                    type="text"
                    v-model="value.defaultPdfContact"
                />
            </div>
            <div class="form-group col-sm-12 col-md-6 col-lg-4">
                <label class="font-weight-bold">
                    {{$t('applicationSettings.signingSettings.defaultPdfLocation')}}
                </label>
                <input class="form-control"
                    type="text"
                    v-model="value.defaultPdfLocation"
                />
            </div>
            <div class="form-group col-sm-12 col-md-6 col-lg-4">
                <label class="font-weight-bold">
                    {{$t('applicationSettings.signingSettings.defaultPdfRectagle')}}
                </label>
                <input class="form-control"
                    type="text"
                    v-model="value.defaultPdfRectagle"
                />
            </div>
            <div class="form-group col-sm-12 col-md-6 col-lg-4">
                <label class="font-weight-bold">
                    Rectangle XStep
                </label>
                <input class="form-control"
                    type="number"
                    step="1"
                    v-model.number="value.defaultPdfXStep"
                />
            </div>
            <div class="form-group col-sm-12 col-md-6 col-lg-4">
                <label class="font-weight-bold">
                    Rectangle YStep
                </label>
                <input class="form-control"
                    type="number"
                    step="1"
                    v-model.number="value.defaultPdfYStep"
                />
            </div>
            <div class="form-group col-sm-12 col-md-6 col-lg-4">
                <label class="font-weight-bold">
                    {{$t('applicationSettings.signingSettings.pdfSignatureVisualizationIsVisible')}}
                </label>
                <vs-checkbox
                    v-model="value.defaultPdfSignatureVisualizationIsVisible"
                    style="justify-content: flex-start !important"
                />
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-sm-12 col-md-6 col-lg-4">
                <label class="font-weight-bold">
                    {{$t('applicationSettings.signingSettings.defaultDocxName')}}
                </label>
                <input class="form-control"
                    type="text"
                    v-model="value.defaultDocxName"
                />
            </div>
            <div class="form-group col-sm-12 col-md-6 col-lg-4">
                <label class="font-weight-bold">
                    {{$t('applicationSettings.signingSettings.defaultDocxTitle')}}
                </label>
                <input class="form-control"
                    type="text"
                    v-model="value.defaultDocxTitle"
                />
            </div>
            <div class="form-group col-sm-12 col-md-6 col-lg-4">
                <label class="font-weight-bold">
                    {{$t('applicationSettings.signingSettings.defaultDocxEmail')}}
                </label>
                <input class="form-control"
                    type="text"
                    v-model="value.defaultDocxEmail"
                />
            </div>
        </div>

        <div>
            <button type="button"
                class="btn btn-outline-secondary btn-sm"
                @click.stop="addUserSettings">
                {{ $t('applicationSettings.signingSettings.addUserSettings')}}
            </button>
        </div>
        <div v-if="value && value.usersSettings">
            <div class="row">
                <div class="col-sm-12 col-md-4"
                    v-for="(item, index) in value.usersSettings"
                    :key="item.reportingServerTemplateId"
                >
                    <div class="card my-2">
                        <div class="card-body">
                            <div class="row">
                                <div class="form-group col-sm-12 col-md-8">
                                    <label class="font-weight-bold">
                                        {{$t('applicationSettings.signingSettings.username')}}
                                    </label>
                                    <kendo-dropdownlist
                                        v-if="users"
                                        v-model="item.username"
                                        :data-source="users"
                                        data-text-field="text"
                                        data-value-field="text"
                                        :optionLabel="$t('choose')"
                                        :filter="'contains'"
                                        style="width: 100%;" />
                                </div>
                                <div class="form-group col-sm-12 col-md-4">
                                    <label class="font-weight-bold">
                                        {{$t('applicationSettings.signingSettings.bookmarkId')}}
                                    </label>
                                    <input class="form-control"
                                        type="text"
                                        v-model="item.bookmarkId"
                                    />
                                </div>
                            </div>

                            <button type="button"
                                class="btn btn-outline-danger btn-sm"
                                @click.stop="deleteUserSettings(index)">
                                {{ $t('buttons.delete.btnText')}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <button type="button"
                class="btn btn-outline-secondary btn-sm"
                @click.stop="addReportingServerTemplate">
                {{ $t('applicationSettings.signingSettings.addReportingTemplate')}}
            </button>
        </div>

        <div v-if="value && value.reportingServerTemplates">
            <div class="row">
                <div class="col-sm-12 col-md-6"
                    v-for="(item, index) in value.reportingServerTemplates"
                    :key="item.reportingServerTemplateId"
                >
                    <div class="card my-2">
                        <div class="card-body">
                            <div class="row">
                                <div class="form-group col-sm-12 col-lg-8">
                                    <label class="font-weight-bold">
                                        {{$t('applicationSettings.signingSettings.reportingTemplateName')}}
                                    </label>
                                    <kendo-dropdownlist
                                        v-model="item.reportingServerTemplateId"
                                        :data-source="reportingServerTemplatesOptions"
                                        data-text-field="text"
                                        data-value-field="id"
                                        :optionLabel="$t('choose')"
                                        style="width: 100%;" />
                                </div>
                                <div class="form-group col-sm-12 col-md-6 col-lg-4">
                                    <label class="font-weight-bold">
                                        {{$t('applicationSettings.signingSettings.reportingTemplatePdfSignatureVisualizatonType')}}
                                    </label>
                                    <kendo-dropdownlist
                                        v-model="item.pdfSignatureVisualizationType"
                                        :data-source="signatureVisualizationTypeOptions"
                                        data-text-field="text"
                                        data-value-field="id"
                                        :optionLabel="$t('choose')"
                                        style="width: 100%;" />
                                </div>
                                <div class="form-group col-sm-12 col-md-6 col-lg-4">
                                    <label class="font-weight-bold">
                                        {{$t('applicationSettings.signingSettings.pdfSignatureVisualizationIsVisible')}}
                                    </label>
                                    <vs-checkbox
                                        v-model="item.pdfSignatureVisualizationIsVisible"
                                        style="justify-content: flex-start !important"
                                    />
                                </div>
                                <div class="form-group col-sm-12 col-md-6 col-lg-4">
                                <label class="font-weight-bold">
                                    {{$t('applicationSettings.signingSettings.pdfReason')}}
                                </label>
                                <input class="form-control"
                                    type="text"
                                    v-model="item.pdfReason"
                                />
                                </div>
                                <div class="form-group col-sm-12 col-md-6 col-lg-4">
                                    <label class="font-weight-bold">
                                        {{$t('applicationSettings.signingSettings.pdfContact')}}
                                    </label>
                                    <input class="form-control"
                                        type="text"
                                        v-model="item.pdfContact"
                                    />
                                </div>
                                <div class="form-group col-sm-12 col-md-6 col-lg-4">
                                    <label class="font-weight-bold">
                                        {{$t('applicationSettings.signingSettings.pdfLocation')}}
                                    </label>
                                    <input class="form-control"
                                        type="text"
                                        v-model="item.pdfLocation"
                                    />
                                </div>
                                <div class="form-group col-sm-12 col-md-6 col-lg-4">
                                    <label class="font-weight-bold">
                                        {{$t('applicationSettings.signingSettings.pdfRectangle')}}
                                    </label>
                                    <input class="form-control"
                                        type="text"
                                        v-model="item.pdfRectagle"
                                    />
                                </div>
                            </div>
                            <button type="button"
                                class="btn btn-outline-danger btn-sm"
                                @click.stop="deleteReportingServerTemplate(index)">
                                {{ $t('buttons.delete.btnText')}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import DynamicDropdown from '@/components/dropdown/DynamicDropdown';
// import Toggle from '@/components/toggle/Toggle';

export default {
    name: 'AppSigningSettingsEditorCompponent',
    components: { },
    props: {
        value: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            users: null,
            reportingServerTemplatesOptions: null,
            signatureVisualizationTypeOptions: [{ id: 'annotation', text: 'annotation' }, { id: 'rectangle', text: 'rectangle' }]
        }
    },
    mounted() {
        this.loadUsers();
        this.loadReportingServerTemplates();
    },
    methods: {
        loadUsers () {
            let url = '/api/dropdown/GetSigningAssigneeUsers';
            const selectedUsernames = [];
            if (this.value) {
                if (this.value.certificateDefaultAssigneeUsername) selectedUsernames.push(this.value.certificateDefaultAssigneeUsername);

                if (Array.isArray(this.value.usersSettings)) {
                    this.value.usersSettings.forEach(element => {
                        selectedUsernames.push(element.username);
                    });
                }
            }

            if (selectedUsernames.length > 0) {
                url += `&selectedUsernames=${selectedUsernames.join()}`;
            }

            this.$http.get(url)
            .then(response => {
                this.users = response.data;
            });
        },
        loadReportingServerTemplates () {
            this.$http.get(`/api/dropdown/GetReportingServerTemplates`)
            .then(response => {
                this.reportingServerTemplatesOptions = response.data;
            });
        },
        addReportingServerTemplate() {
            if (!this.value) return;
            if (!Array.isArray(this.value.reportingServerTemplates)) {
                this.value.reportingServerTemplates = [];
            }

            this.value.reportingServerTemplates.unshift({ reportingServerTemplateId: Math.floor((Math.random()) * 0x10000).toString(16) });
        },
        addUserSettings() {
            if (!this.value) return;
            if (!Array.isArray(this.value.usersSettings)) {
                this.value.usersSettings = [];
            }

            this.value.usersSettings.unshift({ uid: Math.floor((Math.random()) * 0x10000).toString(16) });
        },
        deleteReportingServerTemplate(index) {
            if (!this.value || !Array.isArray(this.value.reportingServerTemplates)) return;

            this.value.reportingServerTemplates.splice(index, 1);
        },
        deleteUserSettings(index) {
            if (!this.value || !Array.isArray(this.value.usersSettings)) return;

            this.value.usersSettings.splice(index, 1);
        },
    }
}
</script>
